import React from 'react';
import '../styles/PageGlobal.css';
import 'swagger-ui-react/swagger-ui.css';
import SwaggerUI from 'swagger-ui-react';
import { API_DOCS_URL } from '../routes/Config';

export default function ApiDocsPage() {
  return React.createElement(
    'div',
    { className: 'containerMain devis-container' },
    React.createElement(
      'div',
      { className: 'devis-header' },
      React.createElement('h1', { className: 'devis-title' }, 'Documentation API')
    ),
    React.createElement(
      'p',
      { className: 'devis-protected' },
      'Documentation interactive des endpoints backend'
    ),
    React.createElement(
      'div',
      { style: { marginTop: '10px' } },
      React.createElement(SwaggerUI, { url: API_DOCS_URL })
    )
  );
}